import {useEffect, useRef, useState} from 'react';
import { signUpload } from '../../../../api';
import Dropzone from 'react-dropzone';
import {toast} from 'react-toastify';
import {toastConfig} from '../../../../config';
import axios from 'axios';

var uploadQueue = [];

const sanitizeFilename = (name) => {
    // Replace non url friendly characters with their url friendly counterparts
    // and spaces with _

    // Separate name form extension
    const ext = name.slice(name.lastIndexOf('.'));
    name = name.slice(0, name.lastIndexOf('.'));

    return (
        name
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '')
            .replace(/[^a-zA-Z0-9-] /g, '')
            .replace(/ /g, '_') + ext
    );
};

const fetchSignUpload = async (serverId) => {
    try {
        const { data } = await signUpload(serverId);
        return data;
    } catch (error) {
        console.log(error);
    }
};

const averageSpeed = (speeds) => {
    if (speeds.length === 0) return 0;

    let sum = 0;
    for (let i = 0; i < speeds.length; i++) {
        sum += speeds[i];
    }

    return Math.round(sum / speeds.length);
};

const File = ({queueItem}) => {
    return (
        <div
            className='flex flex-col bg-off-white rounded-lg p-3 my-2 hover:ring-1 ring-red-1 transition-all w-[15rem]'>
      <span about={queueItem?.file?.name} className='truncate hover:w-fit bg-off-white hover:z-50 font-semibold'>
        {queueItem?.name}
      </span>
            <div>
                {queueItem?.status !== 'uploading' ? (
                    queueItem?.status
                ) : (
                    <div className='flex justify-between '>
                        <span>Est: {queueItem?.time || '--- '}s </span>
                        <span>{averageSpeed(queueItem?.lastSpeeds)} MB/s</span>
                    </div>
                )}
            </div>
            <div className='w-full bg-white h-2 overflow-hidden rounded-xl'>
                <div style={{width: `${queueItem?.progress}%`}} className='bg-red-1 h-full'></div>
            </div>
        </div>
    );
};

let timeout = null;

const Uploader = ({limit, serverId, currentPath, refresh, setLockDeleteFolder, directoryFiles, directoryFolders}) => {
    const [queue, setQueue] = useState([]); // [{file, progress, status}
    const [uploading, setUploading] = useState([]);
    const [showDropzone, setShowDropzone] = useState(false);
    const [lastIndex, setLastIndex] = useState(0);
    const [updateFileState, setUpdateFileState] = useState(false);

    useEffect(() => {
        document.addEventListener('dragover', (e) => {
            if (timeout) clearTimeout(timeout);
            setShowDropzone(true);
        });

        document.addEventListener('dragleave', (e) => {
            timeout = setTimeout(() => {
                setShowDropzone(false);
            }, 200);
        });

        document.addEventListener('drop', (e) => {
            setShowDropzone(false);
        });

        return () => {
            document.removeEventListener('dragover', () => {
            });
            document.removeEventListener('dragleave', () => {
            });
            document.removeEventListener('drop', () => {
            });
        };
    }, []);

    useEffect(() => {
        if (updateFileState) {
            // console.log(updateFileState);

            // const queueItem = queue.find((item) => item.index === updateFileState.index);

            // Find index
            const index = queue.findIndex((item) => item.index === updateFileState.index);

            // console.log(queueItem.file.name, updateFileState.file.name);

            queue[index].progress = updateFileState.progress;
            queue[index].status = updateFileState.status;
            queue[index].time = updateFileState.time;
            queue[index].oldTime = updateFileState.oldTime;
            // console.log('Setting', updateFileState.oldLoaded, 'to', queue[index].file.name, 'oldLoaded');
            queue[index].oldLoaded = updateFileState.oldLoaded;
            queue[index].lastSpeeds = updateFileState.lastSpeeds;

            setQueue([...queue]);
        }
    }, [updateFileState]);

    useEffect(() => {
        console.log(queue);
        handleQueue();
        uploadQueue = queue;
    }, [queue]);

    const uploadFile = async (queueItem, settings) => {
            try {
                const file_data = new FormData();
                file_data.append('video', queueItem.file);

                const purgeOptions = {
                    method: 'post',
                    url: "/api/video-servers/purge",
                    data: {
                        url: `https://${settings.server.replace("origin", "storage")}/videos/${queueItem.path}/${sanitizeFilename(queueItem.file.name)}`
                    }
                };

                const options = {
                    method: 'post',
                    url: `https://${settings.server}/videos/${queueItem.path}`,
                    data: file_data,
                    headers: {
                        token: settings.token,
                        timestamp: settings.timestamp,
                        file_name: sanitizeFilename(queueItem.file.name),
                        'Content-Type': 'video/mp4',
                    },
                    onUploadProgress: (p) => {
                        const progress = {...p};

                        const _queueItem = queue.find((item) => item.index === queueItem.index);
                        const updatePayload = {..._queueItem};
                        const newTime = new Date();

                        if (!updatePayload.oldTime) {
                            updatePayload.oldTime = newTime;
                        }

                        const deltaTime = (newTime - updatePayload.oldTime) / 1000;
                        const deltaSize = (progress.loaded - updatePayload.oldLoaded || 0) / 1000000;
                        const progreso = Math.round((progress.loaded / progress.total) * 100);
                        const velocidad = deltaTime ? Math.round(deltaSize / deltaTime) : 0;

                        updatePayload.progress = progreso;
                        updatePayload.status = 'uploading';

                        if (updatePayload.lastSpeeds.length > 10) {
                            updatePayload.lastSpeeds.shift();
                        }
                        updatePayload.lastSpeeds.push(velocidad);

                        let tiempo = Math.round((progress.total - progress.loaded) / (averageSpeed(updatePayload.lastSpeeds) * 1000000));
                        if (tiempo < 0) {
                            tiempo = 0;
                        }

                        updatePayload.time = tiempo;
                        updatePayload.oldTime = newTime;
                        updatePayload.oldLoaded = progress.loaded;
                        updatePayload.lastSpeeds = updatePayload.lastSpeeds;

                        setUpdateFileState(updatePayload);
                    },
                };

                queueItem.status = 'Comenzando...';
                // setQueue([...queue]);
                axios.request(options).then((response) => {
                    refresh(queueItem.path);
                    queueItem.status = 'Completado';
                    toast.success(`Archivo ${queueItem.file.name} subido correctamente`, toastConfig);

                    axios.request(purgeOptions).then((response) => {
                        toast.success(`Caché purgado para ${queueItem.file.name}`, toastConfig);
                    })
                    updateQueue(queueItem);
                });
            } catch
                (error) {
                console.log(error);
                toast.error(`Error al subir ${queueItem.file.name}`, toastConfig);
            }
        }
    ;

    const handleQueue = async () => {
        if (queue.length == 0) return;
        if (uploading.length >= limit) return;

        let n = limit - uploading.length;

        if (queue.length - uploading.length < n) n = queue.length - uploading.length;

        for (let i = 0; i < queue.length && n > 0; i++) {
            let queueItem = queue[i];
            if (queueItem.status !== 'Esperando') continue;
            n--;
            let settings = await fetchSignUpload(serverId);
            setLockDeleteFolder(true);

            uploadFile(queueItem, settings, queue, setQueue, refresh, setUploading, uploading);
            setUploading([...uploading, queueItem]);
        }
    };

    const handleDrop = (files) => {
        const acceptedTypes = ['video/mp4', 'video/mov', 'video/avi', 'video/mkv', 'video/webm'];

        files = files.filter((file) => {
            if (!acceptedTypes.includes(file.type)) {
                return false;
            } else if (directoryFiles.filter((dFile) => dFile.name === file.name).length) {
                toast.error(`El archivo ${file.name} ya existe`, toastConfig);
                return false;
            } else if (directoryFolders.filter((dFolders) => dFolders.name === file.name).length) {
                toast.error(`Existe una carpeta llamada ${file.name}`, toastConfig);
                return false;
            }
            return true;
        });
        let _lastIndex = lastIndex;
        // console.log('Start last index', _lastIndex);
        files = files.map((file) => {
            return {
                index: _lastIndex++,
                file: file,
                name: sanitizeFilename(file.name),
                progress: 0,
                lastSpeeds: [],
                time: null,
                status: 'Esperando',
                oldTime: null,
                oldLoaded: null,
                path: currentPath.join('/'),
            };
        });
        // console.log('Set last index', _lastIndex);
        setLastIndex(_lastIndex);
        setQueue([...queue, ...files]);
        // if (files) {
        //   console.log('Agregados', files);
        //   console.log('Queue', queue.length);
        // }
    };

    const updateQueue = (queueItem) => {
        const qIndex = queueItem.index;
        const index = uploadQueue.findIndex((item) => item.index === qIndex);
        console.log('Updating', uploadQueue);
        // console.log(queue.length);
        uploadQueue.splice(index, 1);
        // console.log(queue.length);
        setQueue([...uploadQueue]);

        if (uploadQueue.length === 0) {
            setLockDeleteFolder(false);
        }

        setUploading([...uploading.filter((item) => item.index !== qIndex)]);
    };

    return (
        <div className='flex gap-2 w-full overflow-x-auto px-1'>
            <Dropzone onDrop={handleDrop}>
                {({getRootProps, getInputProps}) => (
                    <section style={{display: !showDropzone ? 'none' : 'flex'}} className=''>
                        <div
                            className='flex flex-col justify-center fixed inset-0 text-white bg-[#00000030] p-5 border-4 border-red-1 rounded-lg border-dashed font-semibold text-xl text-center z-50'
                            {...getRootProps()}
                        >
                            <input {...getInputProps()} />
                            <p>Arrastra y suelta los videos aquí.</p>
                            <p>No pueden ser carpetas.</p>
                        </div>
                    </section>
                )}
            </Dropzone>

            {queue.length > 0 &&
                queue.map((queueItem, index) => {
                    return <File key={index} queueItem={queueItem}/>;
                })}
        </div>
    );
};

export default Uploader;
